"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M20.695 17.948a1.306 1.306 0 0 1 .923 2.227 1.306 1.306 0 0 1-.923.382H3.305A1.307 1.307 0 0 1 2 19.253a1.306 1.306 0 0 1 1.305-1.305h17.39Zm0-7.188a1.306 1.306 0 0 1 .923 2.227 1.306 1.306 0 0 1-.923.382H3.305A1.307 1.307 0 0 1 2 12.064a1.305 1.305 0 0 1 1.305-1.304h17.39Zm0-7.317A1.308 1.308 0 0 1 22 4.748a1.308 1.308 0 0 1-1.305 1.304H3.305a1.306 1.306 0 0 1-.923-2.227 1.31 1.31 0 0 1 .923-.382h17.39Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};